import { ErrorType } from '../../../models/HttpError';
import { AppState } from '../../../redux/reducers';
import { AddressViewModel } from '../../../models/Entities/Person/Address/AddressModels';

// store
import * as PersonAddressesStore from '../../../redux/middleware/PersonAddresses.Middleware';

export interface IProps {
  isOpen: boolean;
  openPanel: () => void;
  dismissPanel: () => void;
  PersonId: number;
  addressId?: number | undefined;
}

interface ConnectedProps {
  isAdding: boolean | undefined;
  successAdding: boolean | undefined;
  failAdding: boolean | undefined;
  isUpdating: boolean | undefined;
  successUpdating: boolean | undefined;
  failUpdating: boolean | undefined;
  error: ErrorType | undefined;
  address?: AddressViewModel;
}

interface DispatchProps {
  CreateAddress: typeof PersonAddressesStore.actionCreators.CreateAddress;
  UpdateAddress: typeof PersonAddressesStore.actionCreators.UpdateAddress;
}

export type Props = IProps & ConnectedProps & DispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => ({
  isAdding: state.PersonAddresses?.isAddingNewOne,
  successAdding: state.PersonAddresses?.successAddingNewOne,
  failAdding: state.PersonAddresses?.failOnAddingNewOne,
  isUpdating: state.PersonAddresses?.isUpdatingOne,
  successUpdating: state.PersonAddresses?.successUpdatingOne,
  failUpdating: state.PersonAddresses?.failOnUpdatingOne,
  error: state.PersonAddresses?.error,
  address: state.PersonAddresses?.list.find((item: AddressViewModel) => item.id === ownProps.addressId),
  ...ownProps
});

export const mapDispatchToProps = {
  ...PersonAddressesStore.actionCreators
};
